import * as mutationTypes from "@/store/mutation-types";

export const state = {
    defsData: {}
};

export const mutations = {
    [mutationTypes.SET_DEFS]: (state, payload= {}) => {
        state.defsData = payload
    },
};

export const actions = {
    setDefsData({commit}, data) {
        commit(mutationTypes.SET_DEFS, data);
    },
    deleteDefsData({commit}) {
        commit(mutationTypes.SET_DEFS, {});
    }
};

export const getters = {
        getDefsData: state => state.defsData,
        getDefsEventTypes: state => state.defsData?.eventTypes,
        getDefsLicenceTypes: state => state.defsData?.licenceTypes,
        getDefsNodeTypes: state => state.defsData?.nodeTypes,
        getDefsRolesTypes: state => state.defsData?.roles,
        getDefsServicesXsiTypes: state => state.defsData?.serviceType,
        getReportTypes: state => state.defsData?.reportTypes,
        getGranularityTypes: state => state.defsData?.granularityTypes,
        getMaxIntervalTypes: state => state.defsData?.maxIntervalTypes
};

export default {
    state,
    getters,
    mutations,
    actions
};


